<template>
    <v-container fluid no-gutters class="mx-0 px-0">
        <!-- Attach overlay to body and bump z-index so it sits above v-dialogs (v-dialog uses portals) -->
        <v-overlay :value="overlay" attach="body" absolute :style="{ zIndex: 2147483647 }">
            <v-progress-circular
                color="orange"
                indeterminate
                size="64"
                :style="{ zIndex: 2147483647 }"
            />
        </v-overlay>
        <v-row v-if="orientation === 'portrait'" id="stats" justify="center" align="start" class="font-weight-bold mx-0 px-0">
            <v-col cols="12" class="mx-0 px-0 py-0 my-0">
                <v-row class="font-weight-bold mx-0 px-0 my-0 py-0" align="center">
                    <v-col cols="12" class="mx-0 px-0 my-0 py-0" align="center">
                        <v-btn icon style="position: absolute; top:0; left:0;" @click="changeOrientation()">
                            <v-icon color="orange">{{ `${orientation === 'portrait' ? 'mdi-phone-rotate-landscape' : 'mdi-phone-rotate-portrait'}` }} </v-icon>
                        </v-btn>
                        <v-btn icon style="position: absolute; top:0; left:30px;" @click="$router.push(`/stats/match/alt/${match.id}`)">
                            <v-icon color="orange">mdi-fullscreen</v-icon>
                        </v-btn>
                        {{ `${ getMatchTitle() + ', ' + (match.phase === 'regular_season' ? 'Regular Season' : (match.phase === 'placements' ? 'Προκριματικά' : 'Play Offs')) }` }}
                        {{ `, Matchday ${match.round},` }}
                        <div>
                            {{ `${matchDate}` }}
                        </div>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-1 py-0 my-0" justify="center" align="center">
                    <v-col cols="4" align="center" class="mx-0 px-0 rounded-xl" :style="`background-color: #CD5C5C;`">
                        <div>
                            <v-btn x-small rounded outlined dark @click.stop="setGameRoster(1)" class="mb-1">set game roster</v-btn>
                        </div>
                        <v-avatar style="border-radius: 10px;" size="60" color="white">
                            <v-img width="30px" height="auto" :src="getCountryFlagUrl(match.team1.name)" />
                        </v-avatar>
                        <div class="font-weight-bold white--text" style="font-size: 14px;">{{ `${match.team1.name}` }}</div>
                    </v-col>
                    <v-col cols="4" align="center" class="mx-0 px-0">
                        <span class="mx-2" style="font-size: 20px;" :style="`color: #CD5C5C`">{{ `${match.scoreTeam1}` }}</span>
                        <v-icon small>mdi-minus</v-icon>
                        <span class="mx-2" style="font-size: 20px;" :style="`color: #008080`">{{ `${match.scoreTeam2}` }}</span>
                    </v-col>
                    <v-col cols="4" align="center" class="mx-0 px-0 rounded-xl" :style="`background-color: #008080;`">
                        <div>
                            <v-btn x-small rounded outlined dark @click.stop="setGameRoster(2)" class="mb-1">set game roster</v-btn>
                        </div>
                        <v-avatar style="border-radius: 10px;" size="60" color="white">
                            <v-img width="30px" height="auto" :src="getCountryFlagUrl(match.team2.name)" />
                        </v-avatar>
                        <div class="font-weight-bold white--text" style="font-size: 14px;">{{ `${match.team2.name}` }}</div>
                    </v-col>
                    <v-col cols="12" align="center" class="font-weight-bold py-4">
                        <v-select
                            v-model="quarter"
                            style="display: inline-flex; width:50px; font-size: 16px;"
                            label="Quarter"
                            dense
                            hide-details
                            :items="[1,2,3,4,5,6,7,8,9,10]"
                            class="mr-4"
                        />
                        <span class="match-timer py-2 px-2">
                            <span style="display: inline-block;">
                                <v-btn icon dark color="black" @click="switchTimer()">
                                    <v-icon class="pr-3" dark>{{ paused ? 'mdi-pause' : 'mdi-play' }}</v-icon>
                                </v-btn>
                            </span>
                            <span style="font-size: 16px; display: inline-block;">
                                {{ `${minutes}:${seconds}` }}
                            </span>
                            <v-btn icon color="black" @click="timerDialog = true">
                                <v-icon class="pl-3" color="black">mdi-timer-edit-outline</v-icon>
                            </v-btn>
                        </span>
                        <span class="ml-2">
                            <v-btn dark outlined class="rounded-lg py-4" :color="'#CD5C5C'" @click="timeout()">timeout</v-btn>
                        </span>
                    </v-col>
                    <v-col cols="6" align="center">
                        <v-row class="mx-0 px-0" align="center" justify="center">
                            <v-col cols="6" align="center" class="px-0 my-0 py-1">
                                <v-btn width="95%" dark large class="rounded-lg" :color="'#CD5C5C'" @click="playersDialog=true; currentTeam = 1">sub</v-btn>
                            </v-col>
                            <v-col cols="6" align="center" class="px-0 my-0 py-1">
                                <v-btn width="95%" large class="rounded-lg" dark :color="'#CD5C5C'" @click="dialog=false; category = 'to'; statDialog = false; currentTeam = 1; setStat(selectedPlayer);">to</v-btn>
                            </v-col>
                            <v-col cols="6" align="center" class="px-0 my-0 py-1">
                                <v-btn width="95%" large class="rounded-lg" dark :color="'#CD5C5C'" @click="dialog=false; category = 'dreb'; statDialog = false; currentTeam = 1; setStat(selectedPlayer);">d. reb</v-btn>
                            </v-col>
                            <v-col cols="6" align="center" class="px-0 my-0 py-1">
                                <v-btn width="95%" large class="rounded-lg" dark :color="'#CD5C5C'" @click="dialog=false; category = 'oreb'; statDialog = false; currentTeam = 1; setStat(selectedPlayer);">o. reb</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="6" align="center">
                        <v-row class="mx-0 px-0" align="center" justify="center">
                            <v-col cols="6" align="center" class="px-0 my-0 py-1">
                                <v-btn width="95%" dark large class="rounded-lg" :color="'#008080'" @click="playersDialog=true; currentTeam = 2">sub</v-btn>
                            </v-col>
                            <v-col cols="6" align="center" class="px-0 my-0 py-1">
                                <v-btn width="95%" large class="rounded-lg" dark :color="'#008080'" @click="dialog=false; category = 'to'; statDialog = false; currentTeam = 2; setStat(selectedPlayer);">to</v-btn>
                            </v-col>
                            <v-col cols="6" align="center" class="px-0 my-0 py-1">
                                <v-btn width="95%" large class="rounded-lg" dark :color="'#008080'" @click="dialog=false; category = 'dreb'; statDialog = false; currentTeam = 2; setStat(selectedPlayer);">d. reb</v-btn>
                            </v-col>
                            <v-col cols="6" align="center" class="px-0 my-0 py-1">
                                <v-btn width="95%" large class="rounded-lg" dark :color="'#008080'" @click="dialog=false; category = 'oreb'; statDialog = false; currentTeam = 2; setStat(selectedPlayer);">o. reb</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-1 my-0 py-0">
                        <v-card
                            v-for="player in team1SelectedPlayers"
                            :key="player.id"
                            class="mx-0 px-0 py-0 mt-1 rounded-xl"
                            :style="`background: linear-gradient(110deg, #CD5C5C 30%, white 30%);`"
                            @click="dialog=true; statDialog=true; currentTeam = 1; selectedPlayer = player;"
                        >
                            <v-row justify="center" align="center" class="my-0 mx-0">
                                <v-col cols="3" align="center" class="px-0 mx-0 white--text">
                                    <v-icon v-if="mvp.id === player.id" color="grey"> mdi-crown-outline </v-icon>
                                    <v-icon color="grey"> mdi-pound </v-icon>
                                    {{ `${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey}` }}
                                </v-col>
                                <v-col cols="4" class="px-0 mx-0 py-0 my-0">
                                    <!-- <img
                                        v-if="player.image"
                                        :src="googleApiHost + '/' + player.image"
                                        height="40px"
                                        contain
                                    > -->
                                    <v-icon style="font-size: 40px;" :color="'#CD5C5C'"> mdi-account </v-icon>
                                </v-col>
                                <v-col cols="5" class="px-0 mx-0 py-2" align="start">
                                    {{ getPoints(player, team1) }}p
                                    {{ getRebounds(player, team1) }}r
                                    {{ getAssists(player, team1) }}a
                                    {{ getFouls(player, team1) }}f
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-1 my-0 py-0">
                        <v-card
                            v-for="player in team2SelectedPlayers"
                            :key="player.id"
                            class="mx-0 px-0 py-0 mt-1 rounded-xl"
                            :style="`background: linear-gradient(110deg, #008080 30%, white 30%);`"
                            @click="dialog=true; statDialog=true; currentTeam = 2; selectedPlayer = player;"
                        >
                            <v-row justify="center" align="center" class="my-0 mx-0">
                                <v-col cols="3" align="center" class="px-0 mx-0 white--text">
                                    <v-icon v-if="mvp.id === player.id" color="grey"> mdi-crown-outline </v-icon>
                                    <v-icon color="grey"> mdi-pound </v-icon>
                                    {{ `${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey}` }}
                                </v-col>
                                <v-col cols="4" class="px-0 mx-0 py-0">
                                    <!-- <img
                                        v-if="player.image"
                                        :src="googleApiHost + '/' + player.image"
                                        height="40px"
                                        contain
                                    > -->
                                    <v-icon style="font-size: 40px;" :color="'#008080'"> mdi-account </v-icon>
                                </v-col>
                                <v-col cols="4" class="px-0 mx-0 py-2" align="start">
                                    {{ getPoints(player, team2) }}p
                                    {{ getRebounds(player, team2) }}r
                                    {{ getAssists(player, team2) }}a
                                    {{ getFouls(player, team2) }}f
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="12" class="mx-0 px-0 py-2 my-0">
                        <v-row>
                            <v-col cols="6">
                                <v-expansion-panels dark>
                                    <v-expansion-panel class="rounded-lg">
                                        <v-expansion-panel-header class="text-center d-flex justify-center align-center" style="font-weight: bold;" :style="`background-color: #CD5C5C; color: white;`">
                                            Bench Players
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <div class="bench-scroll">
                                                <span
                                                    v-for="player in team1BenchPlayers"
                                                    :key="player.id"
                                                    class="bench-item"
                                                >
                                                    <div class="bench-entry" @click="dialog=true; statDialog=true; currentTeam = 1; selectedPlayer = player;">
                                                        <v-avatar size="100px" left color="grey">
                                                            <!-- <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" /> -->
                                                            <v-icon color="white" large> mdi-account </v-icon>
                                                        </v-avatar>
                                                        <div class="bench-text">
                                                            {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                                                        </div>
                                                    </div>
                                                </span>
                                            </div>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                            <v-col cols="6">
                                <v-expansion-panels dark>
                                    <v-expansion-panel class="rounded-lg">
                                        <v-expansion-panel-header class="text-center d-flex justify-center align-center" style="font-weight: bold;" :style="`background-color: #008080; color: white;`">
                                            Bench Players
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <div class="bench-scroll">
                                                <span
                                                    v-for="player in team2BenchPlayers"
                                                    :key="player.id"
                                                    class="bench-item"
                                                >
                                                    <div class="bench-entry" @click="dialog=true; statDialog=true; currentTeam = 2; selectedPlayer = player;">
                                                        <v-avatar size="100px" left color="grey">
                                                            <!-- <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" /> -->
                                                            <v-icon color="white" large> mdi-account </v-icon>
                                                        </v-avatar>
                                                        <div class="bench-text">
                                                            {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                                                        </div>
                                                    </div>
                                                </span>
                                            </div>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12">
                        <v-card outlined class="py-2 rounded-lg" style="border: 2px solid black;">
                            <div class="font-weight-bold text-center">
                                <span>Feed:</span>
                                <span>
                                    <v-text-field
                                        v-model="feedFilter"
                                        placeholder="filter feed by jersey..."
                                        dense
                                        hide-details
                                        class="my-2 ml-3"
                                        style="display: inline-flex;"
                                        append-icon="mdi-magnify"
                                    />
                                </span>
                                <div class="d-flex justify-end px-2">
                                    <v-btn
                                        depressed
                                        outlined
                                        color="warning"
                                        small
                                        @click="deleteAllLogsDialog = true"
                                    >
                                        <v-icon
                                            color="warning"
                                        >
                                            mdi-alert
                                        </v-icon>
                                        Delete feed
                                        <v-icon
                                            color="warning"
                                        >
                                            mdi-alert
                                        </v-icon>
                                    </v-btn>
                                </div>
                                <v-dialog
                                    v-model="deleteAllLogsDialog"
                                    width="500"
                                    hide-overlay
                                    persistent
                                    transition="dialog-bottom-transition"
                                    :fullscreen="true"
                                >
                                    <v-card dark class="py-5 px-5">
                                        <v-row align="center" justify="center">
                                            <v-col cols="12" align="center">
                                                <span class="font-weight-bold"> Are you sure? </span>
                                            </v-col>
                                            <v-col cols="6" align="end">
                                                <v-btn dark color="success" @click="deleteAllLogs()">
                                                    yes
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="6" align="start">
                                                <v-btn dark color="error" @click="deleteAllLogsDialog = false">
                                                    no
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-dialog>
                            </div>
                            <v-virtual-scroll
                                :items="filterFeed()"
                                :item-height="50"
                                height="150"
                            >
                                <template v-slot:default="{ item }">
                                    <v-list-item style="font-size: 16px;">
                                        <span style="display: inline-flex;">{{ item.timestamp }}</span>
                                        <v-avatar class="mx-2 rounded-xl" style="display: inline-flex;" :style="item.teamId === team1? `background-color: #CD5C5C;` : `background-color: #008080;`">
                                            <v-img contain height="30px" :src="getTeamLogo(item)" />
                                        </v-avatar>
                                        <span style="display: inline-flex;">{{ getLogText(item) }}</span>
                                        <v-icon
                                            v-if="item.playerMatchStatus === 'stop'"
                                            icon
                                            color="red"
                                            class="mx-2"
                                        >
                                            mdi-arrow-left
                                        </v-icon>
                                        <v-icon
                                            v-else-if="item.playerMatchStatus === 'begin'"
                                            icon
                                            color="green"
                                            class="mx-2"
                                        >
                                            mdi-arrow-right
                                        </v-icon>
                                        <v-spacer />
                                        <v-list-item-action>
                                            <v-btn
                                                depressed
                                                icon
                                                small
                                                @click="deleteDialog = true; logId = item.logId"
                                            >
                                                <v-icon
                                                    color="error"
                                                >
                                                    mdi-trash-can
                                                </v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>
                            </v-virtual-scroll>
                            <v-dialog
                                v-model="deleteDialog"
                                width="500"
                                hide-overlay
                                persistent
                                transition="dialog-bottom-transition"
                                :fullscreen="true"
                            >
                                <v-card dark class="py-5 px-5">
                                    <v-row align="center" justify="center">
                                        <v-col cols="12" align="center">
                                            <span class="font-weight-bold"> Are you sure? </span>
                                        </v-col>
                                        <v-col cols="6" align="end">
                                            <v-btn dark color="success" @click="deleteLog()">
                                                yes
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="6" align="start">
                                            <v-btn dark color="error" @click="deleteDialog = false">
                                                no
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-dialog>
                        </v-card>
                    </v-col>
                    <v-col cols="12" align="center" class="mx-0 px-0 py-0 my-0">
                        <v-btn dark small color="error" class="px-2" @click="endMatchDialog = true">
                            End match
                        </v-btn>
                        <v-dialog
                            v-model="endMatchDialog"
                            width="500"
                            hide-overlay
                            persistent
                            transition="dialog-bottom-transition"
                            :fullscreen="true"
                        >
                            <v-card dark class="py-5 px-5">
                                <v-row align="center" justify="center">
                                    <v-col cols="12" align="center">
                                        <span class="font-weight-bold"> Are you sure? </span>
                                    </v-col>
                                    <v-col cols="6" align="end">
                                        <v-btn dark color="success" @click="endMatch()">
                                            yes
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="6" align="start">
                                        <v-btn dark color="error" @click="endMatchDialog = false">
                                            no
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>
                <v-dialog
                    v-model="timerDialog"
                    width="500"
                    hide-overlay
                    persistent
                    transition="dialog-bottom-transition"
                    :fullscreen="true"
                >
                    <v-card class="px-5 py-5">
                        <v-row align="center" justify="center">
                            <v-col cols="5">
                                <v-text-field
                                    v-model="newMinutes"
                                    type="number"
                                    label="enter minutes"
                                />
                            </v-col>
                            <v-col cols="2" align="center">
                                :
                            </v-col>
                            <v-col cols="5">
                                <v-text-field
                                    v-model="newSeconds"
                                    type="number"
                                    label="enter seconds"
                                />
                            </v-col>
                        </v-row>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn
                                color="primary"
                                text
                                @click="timerDialog = false; changeTimer()"
                            >
                                apply
                            </v-btn>
                            <v-btn
                                color="error"
                                text
                                @click="timerDialog = false; newMinutes = null; newSeconds = null"
                            >
                                close
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
        <v-row v-else id="stats" justify="center" align="start" class="font-weight-bold mx-0 px-0">
            <v-col cols="1" align="center" class="mx-0 px-0 my-0">
                <v-row
                    v-for="player in team1SelectedPlayers"
                    :key="player.id"
                    class="mx-0 px-0 pb-6 mt-1"
                    justify="center"
                    align="center"
                    @click="dialog=true; statDialog=true; currentTeam = 1; selectedPlayer = player;"
                >
                    <v-col cols="12" class="mx-0 px-0 my-0 py-0" align="center">
                        <v-card
                            class="rounded-xl"
                            :style="`background: linear-gradient(110deg, #CD5C5C 30%, white 30%);`"
                        >
                            <div style="top: 0; left: 5px;">
                                <v-icon v-if="mvp.id === player.id" large color="grey"> mdi-crown-outline </v-icon>
                                <v-icon color="grey"> mdi-pound </v-icon>
                                {{ `${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey}` }}
                            </div>
                            <!-- <v-img
                                v-if="player.image"
                                :src="googleApiHost + '/' + player.image"
                                max-height="70px"
                                contain
                            /> -->
                            <v-icon style="font-size: 70px;" :color="'#CD5C5C'"> mdi-account </v-icon>
                            <v-row class="my-0 py-0">
                                <v-col cols="6" align="end" class="py-0 my-0">
                                    <div>{{ getPoints(player, team1) }}p</div>
                                    <div>{{ getRebounds(player, team1) }}r</div>
                                </v-col>
                                <v-col cols="6" align="start" class="py-0 my-0">
                                    <div>{{ getAssists(player, team1) }}a</div>
                                    <div>{{ getFouls(player, team1) }}f</div>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="3" align="center" class="mx-0 px-0">
                <v-row class="mx-0 px-0" align="center" justify="center">
                    <v-col cols="4" align="center" class="px-0">
                        <v-btn width="95%" height="70px" fab dark rounded :color="'#CD5C5C'" @click="dialog=true; currentTeam = 1; made = 'made'; category = '1pt'">1pt</v-btn>
                    </v-col>
                    <v-col cols="4" align="center" class="px-0">
                        <v-btn width="95%" height="70px" fab dark rounded :color="'#CD5C5C'" @click="dialog=true; currentTeam = 1; made = 'made'; category = '2pts'">2pt</v-btn>
                    </v-col>
                    <v-col cols="4" align="center" class="px-0">
                        <v-btn width="95%" height="70px" fab dark rounded :color="'#CD5C5C'" @click="dialog=true; currentTeam = 1; made = 'made'; category = '3pts'">3pt</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0" align="center" justify="center">
                    <v-col cols="4" align="center" class="px-0">
                        <v-btn width="95%" height="70px" fab dark rounded :color="'#CD5C5C'" @click="dialog=true; currentTeam = 1; made = 'missed'; category = '1pt'">
                            <v-icon>mdi-cancel</v-icon>
                            1pt
                        </v-btn>
                    </v-col>
                    <v-col cols="4" align="center" class="px-0">
                        <v-btn width="95%" height="70px" fab dark rounded :color="'#CD5C5C'" @click="dialog=true; currentTeam = 1; made = 'missed'; category = '2pts'">
                            <v-icon>mdi-cancel</v-icon>
                            2pt
                        </v-btn>
                    </v-col>
                    <v-col cols="4" align="center" class="px-0">
                        <v-btn width="95%" height="70px" fab dark rounded :color="'#CD5C5C'" @click="dialog=true; currentTeam = 1; made = 'missed'; category = '3pts'">
                            <v-icon>mdi-cancel</v-icon>
                            3pt
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0" align="center">
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark large class="rounded-lg" :color="'#CD5C5C'" @click="playersDialog=true; currentTeam = 1">sub</v-btn>
                    </v-col>
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark large class="rounded-lg" :color="'#CD5C5C'" @click="dialog=true; currentTeam = 1; foulsDialog = true; category = 'foul'">foul</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0" align="center">
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark large class="rounded-lg" :color="'#CD5C5C'" @click="dialog=true; currentTeam = 1; category = 'dreb'">d. reb</v-btn>
                    </v-col>
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark large class="rounded-lg" :color="'#CD5C5C'" @click="dialog=true; currentTeam = 1; category = 'oreb'">o. reb</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0" align="center">
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark large class="rounded-lg" :color="'#CD5C5C'" @click="dialog=true; currentTeam = 1; category = 'to'">to</v-btn>
                    </v-col>
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark large class="rounded-lg" :color="'#CD5C5C'" @click="dialog=true; currentTeam = 1; category = 'stl'">stl</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0" align="center">
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark large class="rounded-lg" :color="'#CD5C5C'" @click="dialog=true; currentTeam = 1; category = 'asst'">asst</v-btn>
                    </v-col>
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark large class="rounded-lg" :color="'#CD5C5C'" @click="dialog=true; currentTeam = 1; category = 'blk'">blk</v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="px-5">
                        <v-expansion-panels dark>
                            <v-expansion-panel class="rounded-lg">
                                <v-expansion-panel-header class="text-center d-flex justify-center align-center" style="font-weight: bold;" :style="`background-color: #CD5C5C; color: white;`">
                                    Bench Players
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div class="bench-scroll">
                                        <span
                                            v-for="player in team1BenchPlayers"
                                            :key="player.id"
                                            class="bench-item"
                                        >
                                            <div class="bench-entry" @click="dialog=true; statDialog=true; currentTeam = 1; selectedPlayer = player;">
                                                <v-avatar size="100px" left color="grey">
                                                    <!-- <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" /> -->
                                                    <v-icon color="white" large> mdi-account </v-icon>
                                                </v-avatar>
                                                <div class="bench-text">
                                                    {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                                                </div>
                                            </div>
                                        </span>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>
            </v-col>
            <v-col v-if="match" cols="4" align="center" class="mx-0 px-0 py-0">
                <v-btn icon class="my-1" @click="changeOrientation()">
                    <v-icon color="orange">{{ `${orientation === 'portrait' ? 'mdi-phone-rotate-landscape' : 'mdi-phone-rotate-portrait'}` }} </v-icon>
                </v-btn>
                <v-btn icon @click="$router.push(`/stats/match/alt/${match.id}`)">
                    <v-icon color="orange">mdi-fullscreen</v-icon>
                </v-btn>
                <v-row class="font-weight-bold mx-0 px-0" align="center">
                    <v-col cols="12" class="mx-0 px-0" align="center">
                        {{ `${ getMatchTitle() + ', ' + (match.phase === 'regular_season' ? 'Regular Season' : (match.phase === 'placements' ? 'Προκριματικά' : 'Play Offs')) }` }}
                    </v-col>
                </v-row>
                <v-row class="my-0 font-weight-bold mx-0 px-0 py-0" align="center">
                    <v-col cols="12" class="mx-0 px-0 my-0 py-0" align="center">
                        {{ `Round ${match.round}, ${matchDate}` }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 py-0 my-0 mt-2" justify="center" align="center">
                    <v-col cols="5" align="center" class="mx-0 px-0 rounded-xl" :style="`background-color: #CD5C5C;`">
                        <div>
                            <v-btn rounded outlined dark @click.stop="setGameRoster(1)" class="mb-1">set game roster</v-btn>
                        </div>
                        <v-avatar style="border-radius: 10px;" size="60" color="white">
                            <v-img width="40px" height="auto" :src="getCountryFlagUrl(match.team1.name)" />
                        </v-avatar>
                        <div class="font-weight-bold white--text">{{ `${match.team1.name}` }}</div>
                    </v-col>
                    <v-col cols="1" align="center" class="mx-0 px-0 text-h6">
                        vs
                    </v-col>
                    <v-col cols="5" align="center" class="mx-0 px-0 rounded-xl" :style="`background-color: #008080;`">
                        <div>
                            <v-btn rounded outlined dark @click.stop="setGameRoster(2)" class="mb-1">set game roster</v-btn>
                        </div>
                        <v-avatar style="border-radius: 10px;" size="60" color="white">
                            <v-img width="40px" height="auto" :src="getCountryFlagUrl(match.team2.name)" />
                        </v-avatar>
                        <div class="font-weight-bold white--text">{{ `${match.team2.name}` }}</div>
                    </v-col>
                    <v-col cols="4" align="center" class="font-weight-bold">
                        <v-select
                            v-model="quarter"
                            style="display: inline-flex; width:50px; font-size: 20px;"
                            label="Quarter"
                            :items="[1,2,3,4,5,6,7,8,9,10]"
                            hide-details
                        />
                    </v-col>
                    <v-col cols="4" align="center" class="font-weight-bold py-0">
                        <div>
                            <div>score</div>
                            <div>
                                <span class="mx-2" style="font-size: 20px;" :style="`color: #CD5C5C`">{{ `${match.scoreTeam1}` }}</span>
                                <v-icon x-small>mdi-minus</v-icon>
                                <span class="mx-2" style="font-size: 20px;" :style="`color: #008080`">{{ `${match.scoreTeam2}` }}</span>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="4" align="center" class="font-weight-bold py-0">
                        <div>
                            <div>fouls</div>
                            <div>
                                <span class="mx-2" style="font-size: 20px;" :style="`color: #CD5C5C`">{{ `${team1Fouls}` }}</span>
                                <v-icon x-small>mdi-minus</v-icon>
                                <span class="mx-2" style="font-size: 20px;" :style="`color: #008080`">{{ `${team2Fouls}` }}</span>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" class="py-0" align="center">
                        <span class="match-timer py-3">
                            <span style="display: inline-block;">
                                <v-btn icon large dark color="black" @click="switchTimer()">
                                    <v-icon large dark>{{ paused ? 'mdi-pause' : 'mdi-play' }}</v-icon>
                                </v-btn>
                            </span>
                            <span style="font-size: 20px; display: inline-block;" class="mx-5">
                                {{ `${minutes}:${seconds}` }}
                            </span>
                            <v-btn icon x-large color="black" @click="timerDialog = true">
                                <v-icon color="black">mdi-timer-edit-outline</v-icon>
                            </v-btn>
                        </span>
                        <span class="ml-2">
                            <v-btn dark outlined class="rounded-lg py-5" :color="'#CD5C5C'" @click="timeout()">timeout</v-btn>
                        </span>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 mt-2 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'rebounds')[0].team1.rebounds }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        Rebounds
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'rebounds')[0].team2.rebounds }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'steals')[0].team1.steals }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        Steals
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'steals')[0].team2.steals }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'assists')[0].team1.assists }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        Assists
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'assists')[0].team2.assists }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'turnovers')[0].team1.turnovers }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        Turnovers
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'turnovers')[0].team2.turnovers }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'blockedShots')[0].team1.blockedShots }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        Blocks
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'blockedShots')[0].team2.blockedShots }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'personalFouls')[0].team1.personalFouls }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        Fouls
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'personalFouls')[0].team2.personalFouls }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'technicalFouls')[0].team1.technicalFouls }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        T.Fouls
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'technicalFouls')[0].team2.technicalFouls }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'unsportsmanlikeFouls')[0].team1.unsportsmanlikeFouls }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        U.Fouls
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'unsportsmanlikeFouls')[0].team2.unsportsmanlikeFouls }}
                    </v-col>
                </v-row>
                <v-row align="center" justify="center" class="mb-0 mx-5 px-0">
                    <div class="mt-2">
                        <v-card outlined class="py-2 rounded-lg" style="border: 2px solid black;" width="550px">
                            <div class="font-weight-bold text-center">
                                <span>Feed:</span>
                                <span>
                                    <v-text-field
                                        v-model="feedFilter"
                                        placeholder="filter feed by jersey..."
                                        dense
                                        hide-details
                                        class="my-2 ml-3"
                                        style="display: inline-flex;"
                                        append-icon="mdi-magnify"
                                    />
                                </span>
                            </div>
                            <v-virtual-scroll
                                :items="filterFeed()"
                                :item-height="50"
                                height="300"
                            >
                                <template v-slot:default="{ item }">
                                    <v-list-item style="font-size: 16px;">
                                        <span style="display: inline-flex;">{{ item.timestamp }}</span>
                                        <v-avatar class="mx-2 rounded-xl" style="display: inline-flex;" :style="item.teamId === team1? `background-color: #CD5C5C;` : `background-color: #008080;`">
                                            <v-img contain height="30px" :src="getTeamLogo(item)" />
                                        </v-avatar>
                                        <span style="display: inline-flex;">{{ getLogText(item) }}</span>
                                        <v-icon
                                            v-if="item.playerMatchStatus === 'stop'"
                                            icon
                                            color="red"
                                            class="mx-2"
                                        >
                                            mdi-arrow-left
                                        </v-icon>
                                        <v-icon
                                            v-else-if="item.playerMatchStatus === 'begin'"
                                            icon
                                            color="green"
                                            class="mx-2"
                                        >
                                            mdi-arrow-right
                                        </v-icon>
                                        <v-spacer />
                                        <v-list-item-action>
                                            <v-btn
                                                depressed
                                                icon
                                                small
                                                @click="deleteDialog = true; logId = item.logId"
                                            >
                                                <v-icon
                                                    color="error"
                                                >
                                                    mdi-trash-can
                                                </v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>
                            </v-virtual-scroll>
                            <v-dialog
                                v-model="deleteDialog"
                                width="500"
                                hide-overlay
                                persistent
                                transition="dialog-bottom-transition"
                                :fullscreen="true"
                            >
                                <v-card dark class="py-5 px-5">
                                    <v-row align="center" justify="center">
                                        <v-col cols="12" align="center">
                                            <span class="font-weight-bold"> Are you sure? </span>
                                        </v-col>
                                        <v-col cols="6" align="end">
                                            <v-btn dark color="success" @click="deleteLog()">
                                                yes
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="6" align="start">
                                            <v-btn dark color="error" @click="deleteDialog = false">
                                                no
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-dialog>
                        </v-card>
                    </div>
                    <v-dialog
                        v-model="timerDialog"
                        width="500"
                        hide-overlay
                        persistent
                        transition="dialog-bottom-transition"
                        :fullscreen="true"
                    >
                        <v-card class="px-5 py-5">
                            <v-row align="center" justify="center">
                                <v-col cols="5">
                                    <v-text-field
                                        v-model="newMinutes"
                                        type="number"
                                        label="enter minutes"
                                    />
                                </v-col>
                                <v-col cols="2" align="center">
                                    :
                                </v-col>
                                <v-col cols="5">
                                    <v-text-field
                                        v-model="newSeconds"
                                        type="number"
                                        label="enter seconds"
                                    />
                                </v-col>
                            </v-row>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn
                                    color="primary"
                                    text
                                    @click="timerDialog = false; changeTimer()"
                                >
                                    apply
                                </v-btn>
                                <v-btn
                                    color="error"
                                    text
                                    @click="timerDialog = false; newMinutes = null; newSeconds = null"
                                >
                                    close
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
                <v-row>
                    <v-col cols="12" align="center">
                        <v-btn dark large color="error" @click="endMatchDialog = true">
                            End Match
                        </v-btn>
                        <v-dialog
                            v-model="endMatchDialog"
                            width="500"
                            hide-overlay
                            persistent
                            transition="dialog-bottom-transition"
                            :fullscreen="true"
                        >
                            <v-card dark class="py-5 px-5">
                                <v-row align="center" justify="center">
                                    <v-col cols="12" align="center">
                                        <span class="font-weight-bold"> Are you sure? </span>
                                    </v-col>
                                    <v-col cols="6" align="end">
                                        <v-btn dark color="success" @click="endMatch()">
                                            yes
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="6" align="start">
                                        <v-btn dark color="error" @click="endMatchDialog = false">
                                            no
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="3" align="center" class="mx-0 px-0">
                <v-row class="mx-0 px-0" justify="center" align="center">
                    <v-col cols="4" align="center" class="px-0">
                        <v-btn width="95%" height="70px" fab dark rounded :color="'#008080'" @click="dialog=true; currentTeam = 2; made = 'made'; category = '1pt'">1pt</v-btn>
                    </v-col>
                    <v-col cols="4" align="center" class="px-0">
                        <v-btn width="95%" height="70px" fab dark rounded :color="'#008080'" @click="dialog=true; currentTeam = 2; made = 'made'; category = '2pts'">2pt</v-btn>
                    </v-col>
                    <v-col cols="4" align="center" class="px-0">
                        <v-btn width="95%" height="70px" fab dark rounded :color="'#008080'" @click="dialog=true; currentTeam = 2; made = 'made'; category = '3pts'">3pt</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0" justify="center" align="center">
                    <v-col cols="4" align="center" class="px-0">
                        <v-btn width="95%" height="70px" fab dark rounded :color="'#008080'" @click="dialog=true; currentTeam = 2; made = 'missed'; category = '1pt'">
                            <v-icon>mdi-cancel</v-icon>
                            1pt
                        </v-btn>
                    </v-col>
                    <v-col cols="4" align="center" class="px-0">
                        <v-btn width="95%" height="70px" fab dark rounded :color="'#008080'" @click="dialog=true; currentTeam = 2; made = 'missed'; category = '2pts'">
                            <v-icon>mdi-cancel</v-icon>
                            2pt
                        </v-btn>
                    </v-col>
                    <v-col cols="4" align="center" class="px-0">
                        <v-btn width="95%" height="70px" fab dark rounded :color="'#008080'" @click="dialog=true; currentTeam = 2; made = 'missed'; category = '3pts'">
                            <v-icon>mdi-cancel</v-icon>
                            3pt
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0">
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark class="rounded-lg" :color="'#008080'" @click="playersDialog=true; currentTeam = 2">sub</v-btn>
                    </v-col>
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark class="rounded-lg" :color="'#008080'" @click="dialog=true; currentTeam = 2; foulsDialog = true; category = 'foul'">foul</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0">
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark class="rounded-lg" :color="'#008080'" @click="dialog=true; currentTeam = 2; category = 'dreb'">d. reb</v-btn>
                    </v-col>
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark class="rounded-lg" :color="'#008080'" @click="dialog=true; currentTeam = 2; category = 'oreb'">o. reb</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0">
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark class="rounded-lg" :color="'#008080'" @click="dialog=true; currentTeam = 2; category = 'to'">to</v-btn>
                    </v-col>
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark class="rounded-lg" :color="'#008080'" @click="dialog=true; currentTeam = 2; category = 'stl'">stl</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0">
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark class="rounded-lg" :color="'#008080'" @click="dialog=true; currentTeam = 2; category = 'asst'">asst</v-btn>
                    </v-col>
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="70px" dark class="rounded-lg" :color="'#008080'" @click="dialog=true; currentTeam = 2; category = 'blk'">blk</v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="px-5">
                        <v-expansion-panels dark>
                            <v-expansion-panel class="rounded-lg">
                                <v-expansion-panel-header class="text-center d-flex justify-center align-center" style="font-weight: bold;" :style="`background-color: #008080; color: white;`">
                                    Bench Players
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div class="bench-scroll">
                                        <span
                                            v-for="player in team2BenchPlayers"
                                            :key="player.id"
                                            class="bench-item"
                                        >
                                            <div class="bench-entry" @click="dialog=true; statDialog=true; currentTeam = 2; selectedPlayer = player;">
                                                <v-avatar size="100px" left color="grey">
                                                    <!-- <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" /> -->
                                                    <v-icon color="white" large> mdi-account </v-icon>
                                                </v-avatar>
                                                <div class="bench-text">
                                                    {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                                                </div>
                                            </div>
                                        </span>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="1" align="center" class="mx-0 px-0 my-0">
                <v-row
                    v-for="player in team2SelectedPlayers"
                    :key="player.id"
                    class="mx-0 px-0 pb-6 mt-1"
                    justify="center"
                    align="center"
                    @click="dialog=true; statDialog=true; currentTeam = 2; selectedPlayer = player;"
                >
                    <v-col cols="12" class="mx-0 px-0 my-0 py-0" align="center">
                        <v-card
                            class="rounded-xl"
                            :style="`background: linear-gradient(110deg, #008080 30%, white 30%);`"
                        >
                            <div style="top: 0; left: 5px;">
                                <v-icon v-if="mvp.id === player.id" large color="grey"> mdi-crown-outline </v-icon>
                                <v-icon color="grey"> mdi-pound </v-icon>
                                {{ `${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey}` }}
                            </div>
                            <!-- <v-img
                                v-if="player.image"
                                :src="googleApiHost + '/' + player.image"
                                max-height="70px"
                                contain
                            /> -->
                            <v-icon style="font-size: 70px;" :color="'#008080'">
                                mdi-account
                            </v-icon>
                            <v-row class="my-0 py-0">
                                <v-col cols="6" align="end" class="py-0 my-0">
                                    <div>{{ getPoints(player, team2) }}p</div>
                                    <div>{{ getRebounds(player, team2) }}r</div>
                                </v-col>
                                <v-col cols="6" align="start" class="py-0 my-0">
                                    <div>{{ getAssists(player, team2) }}a</div>
                                    <div>{{ getFouls(player, team2) }}f</div>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-dialog
            v-model="gameRosterDialog"
            width="100%"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
            :fullscreen="true"
        >
            <v-card>
                <v-toolbar app width="100%" height="100px" style=" position: sticky; top: 0; z-index: 1000000000; color: white;" :style="currentTeam === 1 ? `background-color: #CD5C5C;` : `background-color: #008080;`">
                    <v-row align="center" justify="center">
                        <v-col cols="12" class="text-h4" align="center">
                            {{ `Game Roster: ${currentTeam == 1? match.gameRosterTeam1.length : match.gameRosterTeam2.length}` }}
                        </v-col>
                        <v-btn
                            outlined
                            dark
                            color="white"
                            class="mb-2"
                            @click="saveGameRoster()"
                        >
                            set game roster
                        </v-btn>
                        <v-btn
                            icon
                            large
                            style="position: absolute; top:0; right:0;"
                            color="white"
                            @click="gameRosterDialog = false; currentTeam = null;"
                        >
                            <v-icon> mdi-close </v-icon>
                        </v-btn>
                    </v-row>
                </v-toolbar>
                <v-row
                    v-if="orientation === 'portrait'"
                    align="center"
                    justify="center"
                    class="px-5 pb-5 pt-5"
                    style="cursor: pointer;"
                >
                    <v-col
                        v-for="player in currentTeam == 1? team1Players : team2Players"
                        :key="player.id"
                        cols="12"
                        align="start"
                    >
                        <v-avatar size="100px" left color="grey">
                            <!-- <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" /> -->
                            <v-icon color="white" large> mdi-account </v-icon>
                        </v-avatar>
                        {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                        <v-btn
                            v-if="currentTeam == 1? match.gameRosterTeam1.find(element => player.id === element) : match.gameRosterTeam2.find(element => player.id === element)"
                            icon
                            color="red"
                            class="mx-2"
                            @click="currentTeam == 1 ? match.gameRosterTeam1 = match.gameRosterTeam1.filter(element => player.id !== element) : match.gameRosterTeam2 = match.gameRosterTeam2.filter(element => player.id !== element)"
                        >
                            <v-icon>
                                mdi-arrow-left
                            </v-icon>
                            out
                        </v-btn>
                        <v-btn
                            v-else
                            icon
                            color="green"
                            class="mx-2"
                            @click="currentTeam == 1 ? match.gameRosterTeam1.push(player.id) : match.gameRosterTeam2.push(player.id)"
                        >
                            in
                            <v-icon>
                                mdi-arrow-right
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row
                    v-else
                    align="start"
                    justify="center"
                    class="px-5 pb-5 pt-5"
                    style="cursor: pointer;"
                >
                    <v-col
                        cols="6"
                        align="start"
                    >
                        <div v-for="player in currentTeam == 1? team1Players : team2Players" :key="`player-${player.id}`">
                            <div v-if="currentTeam == 1? match.gameRosterTeam1.find(element => player.id === element) : match.gameRosterTeam2.find(element => player.id === element)" class="mb-4">
                                <v-avatar size="100px" left color="grey">
                                    <!-- <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" /> -->
                                    <v-icon color="white" large> mdi-account </v-icon>
                                </v-avatar>
                                {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                                <v-btn
                                    icon
                                    color="red"
                                    class="mx-2"
                                    @click="currentTeam == 1 ? match.gameRosterTeam1 = match.gameRosterTeam1.filter(element => player.id !== element) : match.gameRosterTeam2 = match.gameRosterTeam2.filter(element => player.id !== element)"
                                >
                                    <v-icon>
                                        mdi-arrow-left
                                    </v-icon>
                                    out
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                    <v-col
                        cols="6"
                        align="start"
                    >
                        <div v-for="player in currentTeam == 1? team1Players : team2Players" :key="player.id">
                            <div v-if="currentTeam == 1? !match.gameRosterTeam1.find(element => player.id === element) : !match.gameRosterTeam2.find(element => player.id === element)" class="mb-4">
                                <v-avatar size="100px" left color="grey">
                                    <!-- <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" /> -->
                                    <v-icon color="white" large> mdi-account </v-icon>
                                </v-avatar>
                                {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                                <v-btn
                                    icon
                                    color="green"
                                    class="mx-2"
                                    @click="currentTeam == 1 ? match.gameRosterTeam1.push(player.id) : match.gameRosterTeam2.push(player.id)"
                                >
                                    in
                                    <v-icon>
                                        mdi-arrow-right
                                    </v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="error"
                        text
                        @click="gameRosterDialog = false;"
                    >
                        close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="playersDialog"
            width="100%"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
            :fullscreen="true"
        >
            <v-card>
                <v-toolbar app width="100%" height="100px" style=" position: sticky; top: 0; z-index: 1000000000; color: white;" :style="currentTeam === 1 ? `background-color: #CD5C5C;` : `background-color: #008080;`">
                    <v-row align="center" justify="center">
                        <v-col cols="12" class="text-h4" align="center">
                            {{ `Now playing: ${currentTeam == 1? team1SelectedPlayers.length : team2SelectedPlayers.length}` }}
                            <v-btn
                                large
                                color="white"
                                outlined
                                @click="subOutAll()"
                            >
                                Sub Out All
                                <v-icon> mdi-exit-run </v-icon>
                            </v-btn>
                        </v-col>
                        <v-btn
                            icon
                            large
                            style="position: absolute; top:0; right:0;"
                            color="white"
                            @click="playersDialog = false;"
                        >
                            <v-icon> mdi-close </v-icon>
                        </v-btn>
                    </v-row>
                </v-toolbar>
                <v-row
                    v-if="orientation === 'portrait'"
                    align="center"
                    justify="center"
                    class="px-5 pb-5 pt-5"
                    style="cursor: pointer;"
                >
                    <v-col
                        v-for="player in getPlayers()"
                        :key="player.id"
                        cols="12"
                        align="start"
                    >
                        <v-avatar size="100px" left color="grey">
                            <!-- <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" /> -->
                            <v-icon color="white" large> mdi-account </v-icon>
                        </v-avatar>
                        {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                        <v-btn
                            v-if="currentTeam == 1? team1SelectedPlayers.find(element => player.id === element.id) : team2SelectedPlayers.find(element => player.id === element.id)"
                            icon
                            color="red"
                            class="mx-2"
                            @click="removePlayer(player)"
                        >
                            <v-icon>
                                mdi-arrow-left
                            </v-icon>
                            out
                        </v-btn>
                        <v-btn
                            v-else
                            icon
                            color="green"
                            class="mx-2"
                            @click="addPlayer(player)"
                        >
                            in
                            <v-icon>
                                mdi-arrow-right
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row
                    v-else
                    align="start"
                    justify="center"
                    class="px-5 pb-5 pt-5"
                    style="cursor: pointer;"
                >
                    <v-col
                        cols="6"
                        align="start"
                    >
                        <div v-for="player in getPlayers()" :key="`player-${player.id}`">
                            <div v-if="currentTeam == 1? team1SelectedPlayers.find(element => player.id === element.id) : team2SelectedPlayers.find(element => player.id === element.id)" class="mb-4">
                                <v-avatar size="100px" left color="grey">
                                    <!-- <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" /> -->
                                    <v-icon color="white" large> mdi-account </v-icon>
                                </v-avatar>
                                {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                                <v-btn
                                    icon
                                    color="red"
                                    class="mx-2"
                                    @click="removePlayer(player)"
                                >
                                    <v-icon>
                                        mdi-arrow-left
                                    </v-icon>
                                    out
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                    <v-col
                        cols="6"
                        align="start"
                    >
                        <div v-for="player in getPlayers()" :key="player.id">
                            <div v-if="currentTeam == 1? !team1SelectedPlayers.find(element => player.id === element.id) : !team2SelectedPlayers.find(element => player.id === element.id)" class="mb-4">
                                <v-avatar size="100px" left color="grey">
                                    <!-- <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" /> -->
                                    <v-icon color="white" large> mdi-account </v-icon>
                                </v-avatar>
                                {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                                <v-btn
                                    icon
                                    color="green"
                                    class="mx-2"
                                    @click="addPlayer(player)"
                                >
                                    in
                                    <v-icon>
                                        mdi-arrow-right
                                    </v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="error"
                        text
                        @click="playersDialog = false;"
                    >
                        close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialog"
            width="100%"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
            :fullscreen="true"
        >
            <v-card>
                <v-app-bar class="py-2" width="100%" height="150px" style=" position: sticky; top: 0; z-index: 1000000000; color: white;" :style="currentTeam === 1 ? `background-color: #CD5C5C;` : `background-color: #008080;`">
                    <v-row align="center" justify="center">
                        <v-col v-if="statDialog" cols="12" class="text-h6" align="center">
                            {{ currentTeam === 1 ? match.team1.name : match.team2.name }}
                            <div>
                                <v-text-field
                                    v-model="selectedPlayer.alternativeJersey"
                                    color="white"
                                    dark
                                    append-icon="mdi-pencil"
                                    prepend-icon="mdi-pound"
                                    :placeholder="selectedPlayer.jersey"
                                    single-line
                                    hide-details
                                    style="width: 180px; border: 1px solid white; border-radius: 5px;"
                                    class="px-2 py-2"
                                    @click:append="updateSelectedPlayerAlternativeJersey"
                                />
                                <span> {{ `#${selectedPlayer.alternativeJersey || selectedPlayer.alternativeJersey === 0 ? selectedPlayer.alternativeJersey : selectedPlayer.jersey}` }} </span>
                                {{ `${selectedPlayer.name}(${selectedPlayer.jersey})` }}
                            </div>
                        </v-col>
                        <v-col v-else cols="12" class="text-h6" align="center">
                            {{ getCategoryText(category) }}
                            <v-btn v-if="category==='dreb' || category==='oreb' || category==='to'" width="100px" large class="rounded-lg" dark outlined @click="dialog=false; statDialog = false; setStat(selectedPlayer);">team</v-btn>
                        </v-col>
                        <v-btn
                            icon
                            large
                            style="position: absolute; top:0; right:0;"
                            color="white"
                            @click="dialog = false; choice = null; pointsDialog = false; foulsDialog = false; reboundDialog = false; category = null; statDialog = false; selectedPlayer = null;"
                        >
                            <v-icon> mdi-close </v-icon>
                        </v-btn>
                    </v-row>
                </v-app-bar>
                <v-row v-if="statDialog" class="px-5 py-5 mx-0" align="center" justify="center">
                    <v-col cols="12">
                        <v-row class="mx-0 px-0 pt-5" align="center" justify="center">
                            <v-col cols="4" align="center">
                                <v-btn width="95%" height="70px" large fab dark rounded :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="dialog=true; pointsDialog = true; category = '1pt'; statDialog = false; setChoice('made');">1pt</v-btn>
                            </v-col>
                            <v-col cols="4" align="center">
                                <v-btn width="95%" height="70px" large fab dark rounded :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="dialog=true; pointsDialog = true; category = '2pts'; statDialog = false; setChoice('made');">2pt</v-btn>
                            </v-col>
                            <v-col cols="4" align="center">
                                <v-btn width="95%" height="70px" large fab dark rounded :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="dialog=true; pointsDialog = true; category = '3pts'; statDialog = false; setChoice('made');">3pt</v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="mx-0 px-0" align="center" justify="center">
                            <v-col cols="4" align="center">
                                <v-btn width="95%" height="70px" large fab dark rounded :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="dialog=true; pointsDialog = true; statDialog = false; category = '1pt'; setChoice('missed');">
                                    <v-icon>mdi-cancel</v-icon>
                                    1pt
                                </v-btn>
                            </v-col>
                            <v-col cols="4" align="center">
                                <v-btn width="95%" height="70px" large fab dark rounded :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="dialog=true; pointsDialog = true; statDialog = false; category = '2pts'; setChoice('missed');">
                                    <v-icon>mdi-cancel</v-icon>
                                    2pt
                                </v-btn>
                            </v-col>
                            <v-col cols="4" align="center">
                                <v-btn width="95%" height="70px" large fab dark rounded :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="dialog=true; pointsDialog = true; statDialog = false; category = '3pts'; setChoice('missed');">
                                    <v-icon>mdi-cancel</v-icon>
                                    3pt
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="mx-0 px-0" align="center">
                            <v-col cols="6" align="center">
                                <v-btn width="95%" height="70px" large class="rounded-lg" dark :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="playersDialog=true; statDialog = false; dialog=false; removePlayer(selectedPlayer);">sub</v-btn>
                            </v-col>
                            <v-col cols="6" align="center">
                                <v-btn width="95%" height="70px" large class="rounded-lg" dark :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="dialog=true; foulsDialog = true; category = 'foul'; statDialog = false;">foul</v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="mx-0 px-0" align="center">
                            <v-col cols="6" align="center">
                                <v-btn width="95%" height="70px" large class="rounded-lg" dark :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="dialog=false; category = 'dreb'; statDialog = false; setStat(selectedPlayer);">d. reb</v-btn>
                            </v-col>
                            <v-col cols="6" align="center">
                                <v-btn width="95%" height="70px" large class="rounded-lg" dark :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="dialog=false; category = 'oreb'; statDialog = false; setStat(selectedPlayer);">o. reb</v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="mx-0 px-0" align="center">
                            <v-col cols="6" align="center">
                                <v-btn width="95%" height="70px" large class="rounded-lg" dark :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="dialog=false; category = 'to'; statDialog = false; setStat(selectedPlayer);">to</v-btn>
                            </v-col>
                            <v-col cols="6" align="center">
                                <v-btn width="95%" height="70px" large class="rounded-lg" dark :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="dialog=false; category = 'stl'; statDialog = false; setStat(selectedPlayer);">stl</v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="mx-0 px-0" align="center">
                            <v-col cols="6" align="center">
                                <v-btn width="95%" height="70px" large class="rounded-lg" dark :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="dialog=false; category = 'asst'; statDialog = false; setStat(selectedPlayer);">asst</v-btn>
                            </v-col>
                            <v-col cols="6" align="center">
                                <v-btn width="95%" height="70px" large class="rounded-lg" dark :color="currentTeam === 1 ? '#CD5C5C' : '#008080'" @click="dialog=false; category = 'blk'; statDialog = false; setStat(selectedPlayer);">blk</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row v-else-if="reboundDialog" class="px-5 pb-5 pt-16" align="center" justify="center">
                    <v-col cols="12" align="center">
                        <v-btn
                            :color="currentTeam === 1 ? '#008080' : '#CD5C5C'"
                            dark
                            @click="category = 'dreb'; reboundDialog = false; currentTeam = currentTeam === 1 ? 2 : 1;"
                        >
                            Defensive Rebound
                        </v-btn>
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-btn
                            :color="currentTeam === 1 ? '#CD5C5C' : '#008080'"
                            dark
                            @click="category = 'oreb'; reboundDialog = false;"
                        >
                            Offensive Rebound
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-else-if="choice === null && pointsDialog" class="px-5 pb-5 pt-16" align="center" justify="center">
                    <v-col cols="12" align="center">
                        <v-btn
                            color="black"
                            dark
                            @click="setChoice('made')"
                        >
                            <v-icon color="success"> mdi-check </v-icon>
                            made
                        </v-btn>
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-btn
                            color="black"
                            dark
                            @click="setChoice('missed')"
                        >
                            <v-icon color="error"> mdi-close </v-icon>
                            missed
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-else-if="choice === null && foulsDialog" class="px-5 pb-5 pt-16" align="center" justify="center">
                    <v-col cols="12" align="center">
                        <v-btn
                            color="warning"
                            dark
                            @click="setChoice('personal')"
                        >
                            personal
                        </v-btn>
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-btn
                            color="error"
                            dark
                            @click="setChoice('technical')"
                        >
                            technical
                        </v-btn>
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-btn
                            color="black"
                            dark
                            @click="setChoice('unsportsmanlike')"
                        >
                            unsportsmanlike
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row
                    v-else
                    align="center"
                    justify="center"
                    class="px-5 pb-5 pt-5"
                    style="cursor: pointer;"
                >
                    <v-col
                        v-for="player in currentTeam == 1? team1SelectedPlayers : team2SelectedPlayers"
                        :key="player.id"
                        cols="12"
                        align="start"
                        @click="selectedPlayer = player; setChoice(made)"
                    >
                        <v-avatar size="100px" color="grey" left>
                            <!-- <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" /> -->
                            <v-icon color="white" large> mdi-account </v-icon>
                        </v-avatar>
                        {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                    </v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="error"
                        text
                        @click="dialog = false; choice = null; pointsDialog = false; foulsDialog = false; reboundDialog = false; category = null; statDialog = false; selectedPlayer = null;"
                    >
                        close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="retry"
            width="100%"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
            :fullscreen="true"
        >
            <v-alert
                prominent
                type="error"
            >
                <v-row align="center">
                    <v-col class="grow">
                        Oops something went wrong...
                    </v-col>
                    <v-col class="shrink">
                        <v-btn @click="setStat(selectedPlayer)">Retry</v-btn>
                    </v-col>
                    <v-col class="shrink">
                        <v-btn @click="retry=false; dialog = false; pointsDialog = false; foulsDialog = false; reboundDialog = false; playersDialog = false; overlay = false">Close</v-btn>
                    </v-col>
                </v-row>
            </v-alert>
        </v-dialog>
        <v-dialog
            v-model="shootingChartDialog"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
            class="mx-2"
            :fullscreen="true"
        >
            <v-card>
                <v-app-bar class="py-2" width="100%" height="100px" style=" position: sticky; top: 0; z-index: 1000000000; color: white;" :style="currentTeam === 1 ? `background-color: #CD5C5C;` : `background-color: #008080;`">
                    <v-row align="center" justify="center">
                        <v-col cols="12" class="text-h4" align="center">
                            Shooting Chart
                        </v-col>
                        <v-btn
                            icon
                            large
                            style="position: absolute; top:0; right:0;"
                            color="white"
                            @click="shootingChartDialog = false; dialog = false; choice = null; pointsDialog = false; foulsDialog = false; reboundDialog = false; category = null; statDialog = false; selectedPlayer = null;"
                        >
                            <v-icon> mdi-close </v-icon>
                        </v-btn>
                    </v-row>
                </v-app-bar>
                <shooting-chart v-if="shootingChartDialog" class="mt-5" :type="category" :made="choice === 'made'" @updateShots="updateShots" />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="green"
                        outlined
                        :disabled="shots.length === 0"
                        @click="setStat(selectedPlayer); shootingChartDialog = false;"
                    >
                        apply
                    </v-btn>
                    <v-btn
                        v-if="choice === 'missed'"
                        color="black"
                        outlined
                        text
                        :disabled="shots.length === 0"
                        @click="putBack(selectedPlayer); shootingChartDialog = false;"
                    >
                        put back
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Snackbar for success/error messages -->
        <v-snackbar v-model="showSnackbar" :color="snackbarColor" timeout="3000" top>
            {{ snackbarText }}
            <v-btn text @click="showSnackbar = false">Close</v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
    import matchService from '@/services/match'
    import playerService from '@/services/player'
    import momentTimezone from 'moment-timezone'
    import teamService from '@/services/team'
    import ShootingChart from '@/components/ShootingChart.vue'

    export default {
        components: {
            ShootingChart
        },
        data: () => {
            return {
                deleteAllLogsDialog: false,
                shootingChartDialog: false,
                shots: [],
                orientation: 'portrait',
                retry: false,
                statDialog: false,
                deleteDialog: false,
                endMatchDialog: false,
                reboundDialog: false,
                dialog: false,
                playersDialog: false,
                matchDate: null,
                match: {
                    league: null,
                    cupLeague: null,
                    team1: {
                        id: null,
                        name: '',
                        color: '#000000'
                    },
                    gameRosterTeam1: [],
                    team2: {
                        id: null,
                        name: '',
                        color: '#000000'
                    },
                    gameRosterTeam2: []
                },
                googleApiHost: 'https://storage.googleapis.com',
                paused: false,
                team1Players: [],
                team1SelectedPlayers: [],
                team2Players: [],
                team2SelectedPlayers: [],
                currentTeam: null,
                team1: null,
                team1Fouls: 0,
                team2: null,
                team2Fouls: 0,
                pointsDialog: false,
                foulsDialog: false,
                choice: null,
                category: null,
                timer: 600000,
                newMinutes: null,
                newSeconds: null,
                timerDialog: false,
                timerInterval: null,
                feed: [],
                logId: null,
                quarter: 1,
                selectedPlayer: null,
                overlay: false,
                matchStats: {
                    'team1': {
                        'name': '',
                        'players': []
                    },
                    'team2': {
                        'name': '',
                        'players': []
                    }
                },
                created: true,
                stats: [
                    { text: 'Pts', value: 'points', team1: { player: null, points: 0 }, team2: { player: null, points: 0 } },
                    { text: '2P%', value: 'two_points_percentage', team1: { player: null, twoPointAttempts: 0, twoPointsMade: 0, two_points_percentage: 0 }, team2: { player: null, twoPointAttempts: 0, twoPointsMade: 0, two_points_percentage: 0 } },
                    { text: '3P%', value: 'three_points_percentage', team1: { player: null, threePointAttempts: 0, threePointsMade: 0, three_points_percentage: 0 }, team2: { player: null, threePointAttempts: 0, threePointsMade: 0, three_points_percentage: 0 } },
                    { text: 'FT%', value: 'free_throw_percentage', team1: { player: null, freeThrowAttempts: 0, freeThrowsMade: 0, free_throw_percentage: 0 }, team2: { player: null, freeThrowAttempts: 0, freeThrowsMade: 0, free_throw_percentage: 0 } },
                    { text: 'OR', value: 'offensiveRebounds', team1: { player: null, offensiveRebounds: 0 }, team2: { player: null, offensiveRebounds: 0 } },
                    { text: 'DR', value: 'defensiveRebounds', team1: { player: null, defensiveRebounds: 0 }, team2: { player: null, defensiveRebounds: 0 } },
                    { text: 'TR', value: 'rebounds', team1: { player: null, rebounds: 0 }, team2: { player: null, rebounds: 0 } },
                    { text: 'AST', value: 'assists', team1: { player: null, assists: 0 }, team2: { player: null, assists: 0 } },
                    { text: 'STL', value: 'steals', team1: { player: null, steals: 0 }, team2: { player: null, steals: 0 } },
                    { text: 'TO', value: 'turnovers', team1: { player: null, turnovers: 0 }, team2: { player: null, turnovers: 0 } },
                    { text: 'BLK', value: 'blockedShots', team1: { player: null, blockedShots: 0 }, team2: { player: null, blockedShots: 0 } },
                    { text: 'FC', value: 'personalFouls', team1: { player: null, personalFouls: 0 }, team2: { player: null, personalFouls: 0 } },
                    { text: 'TFC', value: 'technicalFouls', team1: { player: null, technicalFouls: 0 }, team2: { player: null, technicalFouls: 0 } },
                    { text: 'USF', value: 'unsportsmanlikeFouls', team1: { player: null, unsportsmanlikeFouls: 0 }, team2: { player: null, unsportsmanlikeFouls: 0 } }
                ],
                made: false,
                mvp: { id: null, points: 0 },
                // snackbar for user feedback
                showSnackbar: false,
                snackbarText: '',
                snackbarColor: 'success',
                feedFilter: null,
                gameRosterDialog: false
            }
        },
        computed: {
            minutes() {
                let temp = Math.floor(this.timer / 60000)
                return (temp < 10 ? '0' : '') + temp
            },
            seconds() {
                let temp = Math.floor(((this.timer % 60000) / 1000))
                return (temp < 10 ? '0' : '') + temp
            },
            team1BenchPlayers() {
                if (this.match.gameRosterTeam1.length === 0) {
                    return this.team1Players.filter(p => !this.team1SelectedPlayers.some(sel => sel.id === p.id))
                } else {
                    return this.team1Players.filter(p =>
                        !this.team1SelectedPlayers.some(sel => sel.id === p.id) &&
                        this.match.gameRosterTeam1.includes(p.id))
                }
            },
            team2BenchPlayers() {
                if (this.match.gameRosterTeam2.length === 0) {
                    return this.team2Players.filter(p => !this.team2SelectedPlayers.some(sel => sel.id === p.id))
                } else {
                    return this.team2Players.filter(p =>
                        !this.team2SelectedPlayers.some(sel => sel.id === p.id) &&
                        this.match.gameRosterTeam2.includes(p.id))
                }
            }
        },
        watch: {
            match() {
                this.getFeed()
                this.getMatchStats()
            },
            timer() {
                if (this.timer === 0 && !this.created) {
                    this.quarter = this.quarter + 1
                    if (this.quarter <= 4) {
                        this.newMinutes = 10
                    } else {
                        this.newMinutes = 5
                    }
                    this.newSeconds = 0
                    this.changeTimer()
                    this.pauseTimer()
                }
            },
            quarter() {
                this.setQuarterFouls()
                if (this.quarter <= 4) {
                    if (!this.created) {
                        this.newMinutes = 10
                        this.newSeconds = 0
                        this.changeTimer()
                        this.pauseTimer()
                    }
                } else {
                    if (!this.created) {
                        this.newMinutes = 5
                        this.newSeconds = 0
                        this.changeTimer()
                        this.pauseTimer()
                    }
                }
                this.created = false
            }
        },
        beforeCreate() {
        },
        created() {
            this.getMatch()
        },
        methods: {
            getCountryFlagUrl(teamName) {
                const country = teamName.split('-')[0].trim()
                console.log('Country:', country)
                const countryCode = this.$countries.getAlpha2Code(country, 'en')
                console.log('Country code:', countryCode)
                if (country === 'MOLDOVA') {
                    return 'https://flagcdn.com/w320/md.png'
                }
                if (!countryCode) {
                    return `https://flagcdn.com/w320/${country.toLowerCase()}.png`
                }
                return `https://flagcdn.com/w320/${countryCode.toLowerCase()}.png`
            },
            getPlayers() {
                if (this.currentTeam === 1) {
                    if (this.match.gameRosterTeam1.length === 0) {
                        return this.team1Players
                    } else {
                        return this.team1Players.filter(player => this.match.gameRosterTeam1.includes(player.id))
                    }
                } else {
                    if (this.match.gameRosterTeam2.length === 0) {
                        return this.team2Players
                    } else {
                        return this.team2Players.filter(player => this.match.gameRosterTeam2.includes(player.id))
                    }
                }
            },
            saveGameRoster() {
                if (this.currentTeam === 1) {
                    matchService.updateMatch(this.match.id, this.match).then(() => {
                        // show success snackbar
                        this.snackbarText = 'Game roster updated successfully'
                        this.snackbarColor = 'success'
                        this.showSnackbar = true
                    }).catch(() => {
                        // show error snackbar
                        this.snackbarText = 'Game roster didnt updated due to an error'
                        this.snackbarColor = 'error'
                        this.showSnackbar = true
                    })
                } else {
                    matchService.updateMatch(this.match.id, this.match).then(() => {
                        // show success snackbar
                        this.snackbarText = 'Game roster updated successfully'
                        this.snackbarColor = 'success'
                        this.showSnackbar = true
                    }).catch(() => {
                        // show error snackbar
                        this.snackbarText = 'Game roster didnt updated due to an error'
                        this.snackbarColor = 'error'
                        this.showSnackbar = true
                    })
                }
                this.gameRosterDialog = false
            },
            setGameRoster(team) {
                if (team === 1) {
                    this.currentTeam = 1
                    this.gameRosterDialog = true
                } else {
                    this.currentTeam = 2
                    this.gameRosterDialog = true
                }
            },
            filterFeed() {
                if (this.feedFilter) {
                    return this.feed.filter(log => {
                        return log.alternativeJersey ? (log.alternativeJersey !== null && log.alternativeJersey !== undefined && log.alternativeJersey.toString() === this.feedFilter) : (log.jersey !== null && log.jersey !== undefined && log.jersey.toString() === this.feedFilter)
                    })
                } else {
                    return this.feed
                }
            },
            subOutAll() {
                if (this.currentTeam === 1) {
                    this.team1SelectedPlayers.forEach((player) => {
                        this.removePlayer(player)
                    })
                    // Force reactivity
                    this.team1SelectedPlayers = []
                } else {
                    this.team2SelectedPlayers.forEach((player) => {
                        this.removePlayer(player)
                    })
                    // Force reactivity
                    this.team2SelectedPlayers = []
                }
            },
            getPoints(player, team) {
                if (team === this.matchStats.team1.id) {
                    if (!this.matchStats || !this.matchStats.team1.players.filter(element => element.id === player.id)[0] || !this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0].points
                } else {
                    if (!this.matchStats || !this.matchStats.team2.players.filter(element => element.id === player.id)[0] || !this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0].points
                }
            },
            getRebounds(player, team) {
                if (team === this.matchStats.team1.id) {
                    if (!this.matchStats || !this.matchStats.team1.players.filter(element => element.id === player.id)[0] || !this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0].rebounds
                } else {
                    if (!this.matchStats || !this.matchStats.team2.players.filter(element => element.id === player.id)[0] || !this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0].rebounds
                }
            },
            getAssists(player, team) {
                if (team === this.matchStats.team1.id) {
                    if (!this.matchStats || !this.matchStats.team1.players.filter(element => element.id === player.id)[0] || !this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0].assists
                } else {
                    if (!this.matchStats || !this.matchStats.team2.players.filter(element => element.id === player.id)[0] || !this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0].assists
                }
            },
            getFouls(player, team) {
                if (team === this.matchStats.team1.id) {
                    if (!this.matchStats || !this.matchStats.team1.players.filter(element => element.id === player.id)[0] || !this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0].personalFouls + this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0].technicalFouls + this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0].unsportsmanlikeFouls
                } else {
                    if (!this.matchStats || !this.matchStats.team2.players.filter(element => element.id === player.id)[0] || !this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0].personalFouls + this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0].technicalFouls + this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0].unsportsmanlikeFouls
                }
            },
            getMatchTitle() {
                if (this.match.cupLeague) {
                    return this.match.cupLeague.title
                } else if (this.match.league) {
                    return this.match.league.title
                } else {
                    return 'Friendly'
                }
            },
            deleteAllLogs() {
                matchService.deleteAllLogs(this.match.id).then(() => {
                    this.deleteAllLogsDialog = false
                    this.getFeed()
                    this.getMatch()
                    this.getActivePlayers()
                }).catch(() => {
                    this.deleteAllLogsDialog = false
                })
            },
            updateShots(shots) {
                this.shots = shots
            },
            setQuarterFouls() {
                this.team1Fouls = this.feed.reduce((acc, log) => {
                    if ((this.quarter <= 4 ? (this.quarter - 1) * 10 : 3 * 10) <= parseInt(log.timestamp.split(':')[0]) && parseInt(log.timestamp.split(':')[0]) < this.quarter * 10 && this.team1 === log.teamId) {
                        return acc +
                            (typeof log.personalFouls !== 'undefined' ? log.personalFouls : 0) +
                            (typeof log.technicalFouls !== 'undefined' ? log.technicalFouls : 0) +
                            (typeof log.unsportsmanlikeFouls !== 'undefined' ? log.unsportsmanlikeFouls : 0)
                    } else {
                        return acc
                    }
                }, 0)
                this.team2Fouls = this.feed.reduce((acc, log) => {
                    if ((this.quarter <= 4 ? (this.quarter - 1) * 10 : 3 * 10) <= parseInt(log.timestamp.split(':')[0]) && parseInt(log.timestamp.split(':')[0]) < this.quarter * 10 && this.team2 === log.teamId) {
                        return acc +
                            (typeof log.personalFouls !== 'undefined' ? log.personalFouls : 0) +
                            (typeof log.technicalFouls !== 'undefined' ? log.technicalFouls : 0) +
                            (typeof log.unsportsmanlikeFouls !== 'undefined' ? log.unsportsmanlikeFouls : 0)
                    } else {
                        return acc
                    }
                }, 0)
            },
            getSecondsFromFeed() {
                return parseInt(this.feed[0].timestamp.split(':')[1])
            },
            getMinutesFromFeed() {
                return parseInt(this.feed[0].timestamp.split(':')[0])
            },
            getMinutes() {
                if (parseInt(this.minutes) === 10 || (parseInt(this.minutes) === 5 && this.quarter > 4)) {
                    if (this.quarter <= 4) {
                        return (this.quarter - 1) * 10
                    } else {
                        return 4 * 10 + (this.quarter - 5) * 5
                    }
                } else {
                    if (this.quarter <= 4) {
                        return (9 - parseInt(this.minutes)) + (this.quarter - 1) * 10
                    } else {
                        return (4 - parseInt(this.minutes)) + 4 * 10 + (this.quarter - 5) * 5
                    }
                }
            },
            getSeconds() {
                if (this.seconds === '00') {
                    return '00'
                } else if ((59 - this.seconds) < 10) {
                    return '0' + (59 - this.seconds)
                } else {
                    return (59 - this.seconds)
                }
            },
            changeOrientation() {
                if (this.$vuetify.breakpoint.xs) {
                    this.orientation = 'portrait'
                } else {
                    this.orientation === 'portrait' ? this.orientation = 'landscape' : this.orientation = 'portrait'
                }
            },
            getMatchValues(matchStats) {
                this.stats = [
                    { text: 'Pts', value: 'points', team1: { player: null, points: 0 }, team2: { player: null, points: 0 } },
                    { text: '2P%', value: 'two_points_percentage', team1: { player: null, twoPointAttempts: 0, twoPointsMade: 0, two_points_percentage: 0 }, team2: { player: null, twoPointAttempts: 0, twoPointsMade: 0, two_points_percentage: 0 } },
                    { text: '3P%', value: 'three_points_percentage', team1: { player: null, threePointAttempts: 0, threePointsMade: 0, three_points_percentage: 0 }, team2: { player: null, threePointAttempts: 0, threePointsMade: 0, three_points_percentage: 0 } },
                    { text: 'FT%', value: 'free_throw_percentage', team1: { player: null, freeThrowAttempts: 0, freeThrowsMade: 0, free_throw_percentage: 0 }, team2: { player: null, freeThrowAttempts: 0, freeThrowsMade: 0, free_throw_percentage: 0 } },
                    { text: 'OR', value: 'offensiveRebounds', team1: { player: null, offensiveRebounds: 0 }, team2: { player: null, offensiveRebounds: 0 } },
                    { text: 'DR', value: 'defensiveRebounds', team1: { player: null, defensiveRebounds: 0 }, team2: { player: null, defensiveRebounds: 0 } },
                    { text: 'TR', value: 'rebounds', team1: { player: null, rebounds: 0 }, team2: { player: null, rebounds: 0 } },
                    { text: 'AST', value: 'assists', team1: { player: null, assists: 0 }, team2: { player: null, assists: 0 } },
                    { text: 'STL', value: 'steals', team1: { player: null, steals: 0 }, team2: { player: null, steals: 0 } },
                    { text: 'TO', value: 'turnovers', team1: { player: null, turnovers: 0 }, team2: { player: null, turnovers: 0 } },
                    { text: 'BLK', value: 'blockedShots', team1: { player: null, blockedShots: 0 }, team2: { player: null, blockedShots: 0 } },
                    { text: 'FC', value: 'personalFouls', team1: { player: null, personalFouls: 0 }, team2: { player: null, personalFouls: 0 } },
                    { text: 'TFC', value: 'technicalFouls', team1: { player: null, technicalFouls: 0 }, team2: { player: null, technicalFouls: 0 } },
                    { text: 'USF', value: 'unsportsmanlikeFouls', team1: { player: null, unsportsmanlikeFouls: 0 }, team2: { player: null, unsportsmanlikeFouls: 0 } }
                ]
                this.stats.forEach((stat) => {
                    matchStats.team1.players.forEach((player) => {
                        if (player.stats.length > 0) {
                            if (stat.value === 'two_points_percentage') {
                                stat.team1.twoPointAttempts += player.stats[0].twoPointAttempts
                                stat.team1.twoPointsMade += player.stats[0].twoPointsMade
                            } else if (stat.value === 'three_points_percentage') {
                                stat.team1.threePointAttempts += player.stats[0].threePointAttempts
                                stat.team1.threePointsMade += player.stats[0].threePointsMade
                            } else if (stat.value === 'free_throw_percentage') {
                                stat.team1.freeThrowAttempts += player.stats[0].freeThrowAttempts
                                stat.team1.freeThrowsMade += player.stats[0].freeThrowsMade
                            } else {
                                stat.team1[stat.value] += player.stats[0][stat.value]
                            }
                        }
                    })
                    stat.team1.two_points_percentage = (stat.team1.twoPointsMade / (stat.team1.twoPointAttempts ? stat.team1.twoPointAttempts : 1) * 100).toFixed(0)
                    stat.team1.three_points_percentage = (stat.team1.threePointsMade / (stat.team1.threePointAttempts ? stat.team1.threePointAttempts : 1) * 100).toFixed(0)
                    stat.team1.free_throw_percentage = (stat.team1.freeThrowsMade / (stat.team1.freeThrowAttempts ? stat.team1.freeThrowAttempts : 1) * 100).toFixed(0)
                    matchStats.team2.players.forEach((player) => {
                        if (player.stats.length > 0) {
                            if (stat.value === 'two_points_percentage') {
                                stat.team2.twoPointAttempts += player.stats[0].twoPointAttempts
                                stat.team2.twoPointsMade += player.stats[0].twoPointsMade
                            } else if (stat.value === 'three_points_percentage') {
                                stat.team2.threePointAttempts += player.stats[0].threePointAttempts
                                stat.team2.threePointsMade += player.stats[0].threePointsMade
                            } else if (stat.value === 'free_throw_percentage') {
                                stat.team2.freeThrowAttempts += player.stats[0].freeThrowAttempts
                                stat.team2.freeThrowsMade += player.stats[0].freeThrowsMade
                            } else {
                                stat.team2[stat.value] += player.stats[0][stat.value]
                            }
                        }
                    })
                    stat.team2.two_points_percentage = (stat.team2.twoPointsMade / (stat.team2.twoPointAttempts ? stat.team2.twoPointAttempts : 1) * 100).toFixed(0)
                    stat.team2.three_points_percentage = (stat.team2.threePointsMade / (stat.team2.threePointAttempts ? stat.team2.threePointAttempts : 1) * 100).toFixed(0)
                    stat.team2.free_throw_percentage = (stat.team2.freeThrowsMade / (stat.team2.freeThrowAttempts ? stat.team2.freeThrowAttempts : 1) * 100).toFixed(0)
                })
            },
            getMatchStats() {
                matchService.getMatchStats(this.$route.params.matchId).then(resp => {
                    this.matchStats = resp.data
                    this.getMatchValues(resp.data)
                    this.setMvp()
                })
            },
            setMvp() {
                if (this.matchStats.team1Score === 0 && this.matchStats.team2Score === 0) {
                    this.mvp = { id: null, points: 0 }
                } else if (this.matchStats.team1Score > this.matchStats.team2Score) {
                    const team1PlayersWithPir = this.matchStats.team1.players.filter(p => p.stats && p.stats[0] && typeof p.stats[0].pir !== 'undefined')
                    this.mvp = team1PlayersWithPir.length > 0 ? team1PlayersWithPir.reduce((max, p) => p.stats[0].pir > max.stats[0].pir ? p : max, team1PlayersWithPir[0]) : { id: null, points: 0 }
                } else {
                    const team2PlayersWithPir = this.matchStats.team2.players.filter(p => p.stats && p.stats[0] && typeof p.stats[0].pir !== 'undefined')
                    this.mvp = team2PlayersWithPir.length > 0 ? team2PlayersWithPir.reduce((max, p) => p.stats[0].pir > max.stats[0].pir ? p : max, team2PlayersWithPir[0]) : { id: null, points: 0 }
                }
            },
            getCategoryText(category) {
                switch (category) {
                case '1pt':
                    return 'POINTS: 1'
                case '2pts':
                    return 'POINTS: 2'
                case '3pts':
                    return 'POINTS: 3'
                case 'dreb':
                    return 'DEFENSIVE REBOUND'
                case 'oreb':
                    return 'OFFENSIVE REBOUND'
                case 'to':
                    return 'TURNOVER'
                case 'stl':
                    return 'STEALS'
                case 'asst':
                    return 'ASSISTS'
                case 'blk':
                    return 'BLOCKS'
                case 'foul':
                    if (this.choice === 'personal') {
                        return 'PERSONAL FOUL'
                    } else if (this.choice === 'technical') {
                        return 'TECHNICAL FOUL'
                    } else {
                        return 'UNSPORTSMANLIKE FOUL'
                    }
                case 'sub-in':
                    return 'SUBSTITUTE IN ->'
                case 'sub-out':
                    return 'SUBSTITUTE OUT <-'
                default:
                    break
                }
            },
            sortPlayers(players) {
                if (players.length > 0) {
                    players.sort((a, b) => {
                        if ((a.alternativeJersey || a.alternativeJersey === 0 ? parseInt(a.alternativeJersey) : a.jersey) < (b.alternativeJersey || b.alternativeJersey === 0 ? parseInt(b.alternativeJersey) : b.jersey)) {
                            return -1
                        }
                        if ((a.alternativeJersey || a.alternativeJersey === 0 ? parseInt(a.alternativeJersey) : a.jersey) > (b.alternativeJersey || b.alternativeJersey === 0 ? parseInt(b.alternativeJersey) : b.jersey)) {
                            return 1
                        }
                        return 0
                    })
                } else {
                    return []
                }
            },
            setChoice(choice) {
                this.choice = choice
                if (this.selectedPlayer) {
                    if (this.category === '2pts' || this.category === '3pts') {
                        this.shootingChartDialog = true
                    } else {
                        this.setStat(this.selectedPlayer)
                    }
                }
            },
            endMatch() {
                let data = {
                    content: `${this.getMinutes()}:${this.getSeconds()}`
                }
                matchService.endMatch(this.$route.params.matchId, data).then(resp => {
                    this.endMatchDialog = false
                    this.$router.go(-1)
                })
            },
            addPlayer(player) {
                if (this.currentTeam === 1 ? this.team1SelectedPlayers.length < 5 : this.team2SelectedPlayers.length < 5) {
                    this.selectedPlayer = player
                    if (this.currentTeam === 1) {
                        this.team1SelectedPlayers = [...this.team1SelectedPlayers, player]
                        this.sortPlayers(this.team1SelectedPlayers)
                        this.sortPlayers(this.team1BenchPlayers)
                    } else {
                        this.team2SelectedPlayers = [...this.team2SelectedPlayers, player]
                        this.sortPlayers(this.team2SelectedPlayers)
                        this.sortPlayers(this.team2BenchPlayers)
                    }
                    this.category = 'sub-in'
                    this.setStat(player)
                }
            },
            removePlayer(player) {
                this.selectedPlayer = player
                if (this.currentTeam === 1 ? this.team1SelectedPlayers.length > 0 : this.team2SelectedPlayers.length > 0) {
                    if (this.currentTeam === 1) {
                        this.team1SelectedPlayers = this.team1SelectedPlayers.filter(element => player.id !== element.id)
                        this.sortPlayers(this.team1SelectedPlayers)
                        this.sortPlayers(this.team1BenchPlayers)
                    } else {
                        this.team2SelectedPlayers = this.team2SelectedPlayers.filter(element => player.id !== element.id)
                        this.sortPlayers(this.team2SelectedPlayers)
                        this.sortPlayers(this.team2BenchPlayers)
                    }
                    this.category = 'sub-out'
                    this.setStat(player)
                }
            },
            getTeamLogo(log) {
                return this.match.team1.id === log.teamId ? this.getCountryFlagUrl(this.match.team1.name) : this.getCountryFlagUrl(this.match.team2.name)
            },
            getMatch() {
                return matchService.getMatch(this.$route.params.matchId).then(resp => {
                    this.match = resp.data
                    this.match.gameRosterTeam1 = this.match.gameRosterTeam1 || []
                    this.match.gameRosterTeam2 = this.match.gameRosterTeam2 || []
                    if (this.match.matchDatetime === null) {
                        this.matchDate = null
                        this.matchTime = null
                    } else {
                        this.matchDate = momentTimezone(this.match.matchDatetime).tz('Europe/Athens').locale('el-GR').format('dddd D/M/y, HH:mm').toString()
                    }
                    this.team1 = resp.data.team1.id
                    this.team2 = resp.data.team2.id
                    // return promises for fetching team players, then populate active players
                    return Promise.all([
                        this.fetchFilteredTeam1Players(resp.data.team1.id),
                        this.fetchFilteredTeam2Players(resp.data.team2.id)
                    ]).then(() => {
                        this.sortPlayers(this.team1Players)
                        this.sortPlayers(this.team2Players)
                        this.getActivePlayers()
                    })
                })
            },
            getActivePlayers() {
                let newTeam1Selected = []
                let newTeam2Selected = []
                matchService.getActivePlayers(this.$route.params.matchId).then(resp => {
                    resp.data.team1Players.forEach(element => {
                        const found = this.team1Players.find(player => player.id === element.playerId)
                        if (found) newTeam1Selected.push(found)
                    })
                    resp.data.team2Players.forEach(element => {
                        const found = this.team2Players.find(player => player.id === element.playerId)
                        if (found) newTeam2Selected.push(found)
                    })
                    this.team1SelectedPlayers = [...newTeam1Selected]
                    this.team2SelectedPlayers = [...newTeam2Selected]
                    this.sortPlayers(this.team1SelectedPlayers)
                    this.sortPlayers(this.team2SelectedPlayers)
                })
            },
            getLogText(log) {
                let temp = ''
                Object.keys(log).forEach(key => {
                    if (key === 'defensiveRebounds') {
                        temp += 'defensive rebound'
                    } else if (key === 'offensiveRebounds') {
                        temp += 'offensive rebound'
                    } else if (key === 'turnovers') {
                        temp += 'turnover'
                    } else if (key === 'turnovers') {
                        temp += 'turnover'
                    } else if (key === 'steals') {
                        temp += 'steal'
                    } else if (key === 'assists') {
                        temp += 'assist'
                    } else if (key === 'playerMatchStatus' && log[key] === 'begin') {
                        temp += 'subbed in'
                    } else if (key === 'playerMatchStatus' && log[key] === 'stop') {
                        temp += 'subbed out'
                    } else if (key === 'blockedShots') {
                        temp += 'block'
                    } else if (key === 'personalFouls') {
                        temp += 'personal foul'
                    } else if (key === 'technicalFouls') {
                        temp += 'technical foul'
                    } else if (key === 'unsportsmanlikeFouls') {
                        temp += 'unsportmanlike foul'
                    } else if (key === 'freeThrowsMade' && log[key] === 1) {
                        temp += 'free throw made'
                    } else if (key === 'freeThrowAttempts' && log['freeThrowsMade'] === 0) {
                        temp += 'free throw missed'
                    } else if (key === 'twoPointsMade' && log[key] === 1) {
                        temp += '2pt made'
                    } else if (key === 'twoPointAttempts' && log['twoPointsMade'] === 0) {
                        temp += '2pt missed'
                    } else if (key === 'threePointsMade' && log[key] === 1) {
                        temp += '3pt made'
                    } else if (key === 'threePointAttempts' && log['threePointsMade'] === 0) {
                        temp += '3pt missed'
                    }
                })
                if (log.playerId === 0) {
                    return `team ${temp}`
                } else {
                    return `#${log.alternativeJersey || log.alternativeJersey === 0 ? log.alternativeJersey : log.jersey} ${temp}`
                }
            },
            getFeed() {
                matchService.getMatchLogs(this.$route.params.matchId).then((resp) => {
                    if (resp.data.length === 0) {
                        this.feed = []
                        this.created = false
                        return
                    }
                    this.feed = resp.data
                        .sort((a, b) => {
                            const toMs = s => {
                                const parts = (s || '').split(':')
                                const min = parseInt(parts[0], 10) || 0
                                const sec = parseInt(parts[1], 10) || 0
                                return min * 60000 + sec * 1000
                            }
                            // descending: newest (largest elapsed) first
                            return toMs(b.timestamp) - toMs(a.timestamp)
                        })
                    this.updateTimerFromFeed()
                    this.setQuarterFouls()
                })
            },
            updateTimerFromFeed() {
                if (!this.created) return
                if (this.feed && this.feed.length > 0 && this.feed[0] && this.feed[0].timestamp) {
                    const [minStr, secStr] = this.feed[0].timestamp.split(':')
                    this.quarter = Math.floor((parseInt(minStr) || 0) / 10) + 1
                    // compute total elapsed seconds from feed timestamp
                    const totalElapsedSeconds = (parseInt(minStr) || 0) * 60 + (parseInt(secStr) || 0)
                    // quarter duration in seconds (10min regulation, 5min overtime)
                    const quarterDurationSec = this.quarter <= 4 ? 10 * 60 : 5 * 60

                    // compute elapsed seconds at the start of this quarter (supports overtime)
                    let quarterStartElapsedSeconds = 0
                    if (this.quarter <= 4) {
                        quarterStartElapsedSeconds = (this.quarter - 1) * 10 * 60
                    } else {
                        quarterStartElapsedSeconds = 4 * 10 * 60 + (this.quarter - 1 - 4) * 5 * 60
                    }

                    let elapsedInQuarter = totalElapsedSeconds - quarterStartElapsedSeconds
                    if (elapsedInQuarter < 0) elapsedInQuarter = 0
                    const remainingSeconds = quarterDurationSec - elapsedInQuarter
                    this.timer = Math.max(0, remainingSeconds * 1000)
                } else {
                    this.quarter = 1
                    this.timer = 10 * 60 * 1000
                }
            },
            deleteLog() {
                let log = this.feed.filter((element) => this.logId === element.logId)[0]
                matchService.deleteMatchLog(this.match.id, this.logId).then((resp) => {
                    this.deleteDialog = false
                    this.feed = resp.data
                    if (log.playerMatchStatus === 'stop' || log.playerMatchStatus === 'begin') {
                        this.getActivePlayers()
                    }
                    this.getMatch()
                })
            },
            putBack(selectedPlayer) {
                this.retry = false
                this.overlay = true
                let data = {
                    period: this.quarter,
                    teamId: this.currentTeam === 1 ? this.team1 : this.team2,
                    playerId: selectedPlayer.id,
                    jersey: selectedPlayer.jersey,
                    alternativeJersey: selectedPlayer.alternativeJersey,
                    timestamp: `${this.getMinutes()}:${this.getSeconds()}`
                }
                switch (this.category) {
                case '2pts':
                    data.throwCoordinates = { ...this.shots[0], throwStatus: 'putback' }
                    data.twoPointsMade = 1
                    data.twoPointAttempts = 2
                    data.offensiveRebounds = 1
                    break
                case '3pts':
                    data.throwCoordinates = { ...this.shots[0], throwStatus: 'putback' }
                    data.threePointsMade = 1
                    data.threePointAttempts = 2
                    break
                default:
                    break
                }
                matchService.importMatchLog(this.match.id, data).then((resp) => {
                    this.choice = null
                    this.pointsDialog = false
                    this.foulsDialog = false
                    this.dialog = false
                    setTimeout(() => {
                        this.overlay = false
                        this.dialog = true
                        this.reboundDialog = true
                    }, '500')
                    this.match = resp.data
                    this.match.gameRosterTeam1 = this.match.gameRosterTeam1 || []
                    this.match.gameRosterTeam2 = this.match.gameRosterTeam2 || []
                    this.selectedPlayer = null
                }).catch(() => {
                    this.dialog = false
                    this.pointsDialog = false
                    this.foulsDialog = false
                    this.reboundDialog = false
                    this.playersDialog = false
                    this.overlay = false
                    this.retry = true
                })
            },
            setStat(player) {
                this.retry = false
                this.overlay = true
                let data = {
                    period: this.quarter,
                    teamId: this.currentTeam === 1 ? this.team1 : this.team2,
                    playerId: player ? player.id : 0,
                    jersey: player ? player.jersey : null,
                    alternativeJersey: player ? player.alternativeJersey : null,
                    timestamp: `${this.getMinutes()}:${this.getSeconds()}`
                }
                switch (this.category) {
                case '1pt':
                    if (this.choice === 'made') {
                        data.freeThrowsMade = 1
                        data.freeThrowAttempts = 1
                    } else {
                        data.freeThrowAttempts = 1
                    }
                    break
                case '2pts':
                    data.throwCoordinates = this.shots[0]
                    if (this.choice === 'made') {
                        data.twoPointsMade = 1
                        data.twoPointAttempts = 1
                    } else {
                        data.twoPointAttempts = 1
                    }
                    break
                case '3pts':
                    console.log('in 3pts')
                    console.log(this.shots)
                    data.throwCoordinates = this.shots[0]
                    if (this.choice === 'made') {
                        data.threePointsMade = 1
                        data.threePointAttempts = 1
                    } else {
                        data.threePointAttempts = 1
                    }
                    break
                case 'dreb':
                    data.defensiveRebounds = 1
                    break
                case 'oreb':
                    data.offensiveRebounds = 1
                    break
                case 'to':
                    data.turnovers = 1
                    break
                case 'stl':
                    data.steals = 1
                    break
                case 'asst':
                    data.assists = 1
                    break
                case 'blk':
                    data.blockedShots = 1
                    break
                case 'foul':
                    if (this.choice === 'personal') {
                        data.personalFouls = 1
                    } else if (this.choice === 'technical') {
                        data.technicalFouls = 1
                    } else {
                        data.unsportsmanlikeFouls = 1
                    }
                    break
                case 'sub-in':
                    data.playerMatchStatus = 'begin'
                    break
                case 'sub-out':
                    data.playerMatchStatus = 'stop'
                    break
                default:
                    break
                }
                matchService.importMatchLog(this.match.id, data).then((resp) => {
                    if ((this.category === '2pts' || this.category === '3pts') && this.choice === 'made') {
                        this.choice = null
                        this.pointsDialog = false
                        this.foulsDialog = false
                        this.reboundDialog = false
                        this.dialog = false
                        setTimeout(() => {
                            this.overlay = false
                            this.dialog = true
                            this.category = 'asst'
                        }, '500')
                    } else if ((this.category === '2pts' || this.category === '3pts' || this.category === '1pt') && this.choice === 'missed') {
                        this.choice = null
                        this.pointsDialog = false
                        this.foulsDialog = false
                        this.dialog = false
                        setTimeout(() => {
                            this.overlay = false
                            if (this.category !== '1pt') {
                                this.reboundDialog = true
                                this.dialog = true
                            } else {
                                this.dialog = false
                            }
                        }, '500')
                    } else if (this.category === 'stl') {
                        this.currentTeam = this.currentTeam === 1 ? 2 : 1
                        this.choice = null
                        this.pointsDialog = false
                        this.foulsDialog = false
                        this.reboundDialog = false
                        this.dialog = false
                        setTimeout(() => {
                            this.dialog = true
                            this.overlay = false
                            this.category = 'to'
                        }, '500')
                    } else if (this.category === 'foul') {
                        setTimeout(() => {
                            this.overlay = false
                        }, '500')
                        this.dialog = false
                        this.pointsDialog = false
                        this.foulsDialog = false
                        this.category = null
                        this.choice = null
                        this.reboundDialog = false
                        this.pauseTimer()
                    } else {
                        this.dialog = false
                        this.pointsDialog = false
                        this.foulsDialog = false
                        this.category = null
                        this.choice = null
                        this.reboundDialog = false
                        setTimeout(() => {
                            this.overlay = false
                        }, '500')
                    }
                    this.match = resp.data
                    this.match.gameRosterTeam1 = this.match.gameRosterTeam1 || []
                    this.match.gameRosterTeam2 = this.match.gameRosterTeam2 || []
                    this.selectedPlayer = null
                }).catch(() => {
                    this.dialog = false
                    this.pointsDialog = false
                    this.foulsDialog = false
                    this.reboundDialog = false
                    this.playersDialog = false
                    this.overlay = false
                    this.retry = true
                })
            },
            fetchFilteredTeam1Players(id) {
                this.loading = true
                return teamService.getTeam(id).then(resp => {
                    this.team1Players = resp.data.players
                    this.loading = false
                })
            },
            fetchFilteredTeam2Players(id) {
                this.loading = true
                return teamService.getTeam(id).then(resp => {
                    this.team2Players = resp.data.players
                    this.loading = false
                })
            },
            getPlayerText(item) {
                return `#${item.jersey} ${item.name}`
            },
            // openFullscreen() {
            //     var elem = document.getElementById('stats')
            //     if (elem.requestFullscreen) {
            //         elem.requestFullscreen()
            //     } else if (elem.webkitRequestFullscreen) { /* Safari */
            //         elem.webkitRequestFullscreen()
            //     } else if (elem.msRequestFullscreen) { /* IE11 */
            //         elem.msRequestFullscreen()
            //     }
            // },
            switchTimer() {
                this.paused = !this.paused
                matchService.editTimer(this.match.id, this.paused ? 'start' : 'stop', this.timer, this.quarter).then(() => {}).catch(() => {})
                if (!this.paused) {
                    clearInterval(this.timerInterval)
                } else if (this.timer > 0) {
                    this.timerInterval = setInterval(() => {
                        this.timer = this.timer - 1000
                    }, 1000)
                }
            },
            pauseTimer() {
                this.paused = false
                matchService.editTimer(this.match.id, 'stop', this.timer, this.quarter).then(() => {}).catch(() => {})
                clearInterval(this.timerInterval)
            },
            timeout() {
                this.paused = false
                matchService.editTimer(this.match.id, 'timeout', this.timer, this.quarter).then(() => {}).catch(() => {})
                clearInterval(this.timerInterval)
            },
            changeTimer() {
                this.timer = parseInt(this.newMinutes) * 60000 + parseInt(this.newSeconds) * 1000
            },
            updateSelectedPlayerAlternativeJersey() {
                this.overlay = true
                playerService.setAlternativeJerseyOnPlayer(this.selectedPlayer.id, this.selectedPlayer.alternativeJersey.toString()).then(() => {
                    this.overlay = false
                    if (this.currentTeam === 1) {
                        this.sortPlayers(this.team1SelectedPlayers)
                        this.sortPlayers(this.team1BenchPlayers)
                        this.sortPlayers(this.team1Players)
                    } else {
                        this.sortPlayers(this.team2SelectedPlayers)
                        this.sortPlayers(this.team2BenchPlayers)
                        this.sortPlayers(this.team2Players)
                    }
                    // show success snackbar
                    this.snackbarText = 'Alternative jersey updated'
                    this.snackbarColor = 'success'
                    this.showSnackbar = true
                }).catch(() => {
                    this.selectedPlayer.alternativeJersey = null
                    this.overlay = false
                    // show error snackbar
                    this.snackbarText = 'Failed to update alternative jersey'
                    this.snackbarColor = 'error'
                    this.showSnackbar = true
                })
            }
        }
    }
</script>

<style scoped>
    .match-timer{
        font-weight: 700;
        border: 2px solid black;
        border-radius: 10px;
    }

    .match-timer-danger{
        border-color: red !important;
        color: red !important;
    }
    .overlay {
        position: absolute;
        bottom: 0;
        background: rgb(0, 0, 0);
        background: rgba(0, 0, 0, 0.5); /* Black see-through */
        color: #f1f1f1;
        width: 100%;
        transition: .5s ease;
        opacity:0;
        color: white;
        font-size: 20px;
        padding: 20px;
        text-align: center;
    }

    .full-width-on-open.v-expansion-panel--active .v-expansion-panel-content {
        max-height: calc(100vh - 56px);
        overflow: auto;
    }

    /* horizontal scrolling for bench players */
    .bench-scroll {
        display: flex;
        flex-direction: row;
        gap: 12px;
        padding: 12px;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
    }

    .bench-item {
        flex: 0 0 auto;
        display: inline-flex;
        align-items: center;
    }

    .bench-entry {
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 120px;
    }

    .bench-text {
        margin-top: 8px;
        text-align: center;
        font-weight: 600;
    }
</style>
